

import './style.css'
const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__copyright">
                    <p>©2022-2023, Календарь образовательных событий региональной системы научно-методического сопровождения педагогических работников Чеченской Республики </p>
                </div>
            </div>
        </footer >
    );
}

export default Footer;